import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/icons/logo_colors.png'
import _imports_1 from '../assets/icons/logo_white.png'


const _hoisted_1 = { class: "relative group z-0" }
const _hoisted_2 = { class: "transition perspect-800px duration-500 preserve-3d transform-gpu" }
const _hoisted_3 = {
  key: 0,
  class: "w-118px h-135px <xl:w-70px <xl:h-80px <sm:w-43px <sm:h-50px",
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  class: "w-118px h-135px <xl:w-70px <xl:h-80px <sm:w-43px <sm:h-50px",
  src: _imports_1
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.white)
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : (_openBlock(), _createElementBlock("img", _hoisted_4))
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(["text-14px <xl:text-12px <lg:text-10px <lg:-bottom-20px <xl:-bottom-25px font-400 abs-horiz-center uppercase -bottom-30px whitespace-nowrap", { 'text-white': _ctx.white }])
    }, " Партнерство для прогресса ", 2)
  ]))
}